import React, {PureComponent} from "react";
import {GameEntity} from "../data/entities/GameEntity";
import {FormattedMessage} from "react-intl";
interface Props {
    game: GameEntity;
    closeAlert: () => void;
    activateGame: (activatedGame: GameEntity) => void;
}

export default class SaveFileAlertModal extends PureComponent<Props> {
    componentDidMount(): void {
        document.body.classList.add('overflow-hidden');
    }

    componentWillUnmount(): void {
        document.body.classList.remove('overflow-hidden');
    }

    render(): JSX.Element {
        return (
            <div className="alertOverlay" onClick={this.props.closeAlert}>
                <div className="alertOuter" onClick={e => e.stopPropagation()}>
                    <div className="alertInner">
                        <div className="alertHeader">
                            <button type="button" className="alertClose" aria-label="Close this dialog" onClick={this.props.closeAlert}>
                                ×
                            </button>
                        </div>
                        <div className="alertBox">
                            <h3 className="alertTitle">
                                <FormattedMessage id="warning.savefiles_alert.title"/>
                            </h3>
                            <div className="alertContent">
                                <div className="alertImage">
                                    <img src={this.props.game.image} alt={this.props.game.name} />
                                </div>
                                <div className="alertText">
                                    <FormattedMessage
                                        id="warning.savefiles_alert.body"
                                        values={{
                                            here: <a href="https://support.ubi.com/Faqs/000047597" target="_blank" rel="noopener noreferrer">
                                                <FormattedMessage id="warning.savefiles_alert.body.here"/>
                                            </a>
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="alertFooter">
                            <button type="button" className="alertCancel" aria-label="Cancel" onClick={this.props.closeAlert}>
                                <FormattedMessage id="warning.savefiles_alert.cancel"/>
                            </button>

                            <button type="button" className="alertConfirm" aria-label="Confirm" onClick={this.activateGame}>
                                <FormattedMessage id="warning.savefiles_alert.confirm"/>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    activateGame = () => {
        this.props.closeAlert();
        this.props.activateGame(this.props.game);
    };
}